<template>
	<div class="edit-address">
		<div class="title">申请返修</div>

		<div class="input-box">
			<div class="title">寄回地址: </div>
			<p>{{info.contact_person}}</p>
		</div>
		<div class="input-box">
			<div class="title">寄回地址: </div>
			<p>{{info.contact_address}}</p>
		</div>
		<div class="input-box">
			<div class="title">联系电话:</div>
			<p>{{info.contact_mobile}}</p>
		</div>
		<div class="input-box">
			<div class="title">快递公司：</div>
			<input v-model="info.logistics_company" placeholder="请填写快递公司" />
		</div>
		<div class="input-box">
			<div class="title">快递单号：</div>
			<input v-model="info.logistics_no" placeholder="请填写快递单号" />
		</div>
		<button class="save" @click="save">保存</button>

	</div>
</template>

<script>
	import { GetManageRefundAddress, CustomerSend } from "@/api"
	export default {
		name: 'Fixing',
		components: {

		},
		data() {
			return {
				value: [],
				info: {
					id: 0,
					contact_person:'',
					contact_mobile:'',
					contact_address:'',
					logistics_company:'',
					logistics_no:''
				}
			};
		},
		created() {
			this.info.id = this.$route.query.id
			GetManageRefundAddress().then((response)=>{
				let { RefundAddress, RefundContact, RefundMobile} = response.data
				this.info.contact_person = RefundContact
				this.info.contact_mobile = RefundMobile
				this.info.contact_address = RefundAddress
			})
		},
		methods: {
			async save() {
				if(!this.info.logistics_company || !this.info.logistics_no) {
					this.$Notice.error({
						title: '请填写完整的快递公司和快递单号',
						duration: 1,
					})
					return
				}

				let res = await CustomerSend(this.info)
				this.$Notice.success({
					title:  '提交成功',
				});
				this.$router.back();
			},
		}
	}
</script>

<style lang="scss" scoped>
	.edit-address {
		width: 950px;
		height: 560px;
		background: #FFFFFF;
		border: 1px solid #EEEEEE;
		padding: 20px;

		.title {
			font-size: 20px;
			font-weight: bold;
			color: #333333;
			margin-bottom: 20px;
		}

		.input-box {
			margin-bottom: 30px;
			display: flex;

			.title {
				width: 86px;

				font-size: 14px;
				color: #666666;
			}

			input {
				width: 440px;
				height: 40px;
				line-height: 40px;
				background: #FFFFFF;
				border: 1px solid #dcdee2;
				padding-left: 20px;
				color: #333333;
			}

			textarea {
				width: 440px;
				height: 80px;
				border: 1px solid #dcdee2;
				padding-left: 20px;
				padding-top: 10px;
			}
		}

		.save {
			width: 100px;
			height: 40px;
			line-height: 40px;
			background: #0F114A;
			text-align: center;
			font-size: 14px;
			color: #FFFFFF;
			margin-left: 86px;
			padding-bottom: 30px;
		}

		.default {
			margin-left: 86px;
			padding-bottom: 20px;

			.ivu-checkbox-checked .ivu-checkbox-inner {

				border-color: #0F114A !important;
				background-color: #0F114A !important;
			}
		}
	}
</style>
